import { AccountActions } from '../../components/account-actions'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import {
    AccountTopWrapper,
    Heading,
    Container,
    MainContent,
    CustomAvatar,
    MainContentWrapper
} from '../../styles/account'



const Account = () => {
    return (
        <DashboardWrapper>
            <AccountTopWrapper>
                <Container>
                    <MainContent>
                        <div className="top">
                            <h1 className="account-name">Bidemi Ajala</h1>
                            <div className="image-container">
                                <CustomAvatar alt="Name" src="/assets/images/account-avatar.webp" />
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="school-info">
                                <p className="main-school">Klasconnect Portal</p>
                                <p className="sub-school">Temple College, Lagos State.</p>
                            </div>
                            <div className="class-info">
                                <p className="main-school">Class: JSS1</p>
                                <p className="sub-school">REGISTRATION ID: 010</p>
                            </div>
                            <div className="contact-info">
                                <p className="personal-number">Personal Number: 09092232851</p>
                                <p className="parent-number">Parent's Number: 09092232851</p>
                            </div>
                        </div>
                    </MainContent>
                </Container>
            </AccountTopWrapper>
            <MainContentWrapper>
                <MainContent>
                    <Container>
                        <Heading>Welcome, Bidemi</Heading>
                        <AccountActions />
                    </Container>
                </MainContent>
            </MainContentWrapper>

        </DashboardWrapper>
    )
}

export default Account
